import React, { useState } from "react";
import { Play, X } from "lucide-react";
import { VIDEOS } from "../mock";

const Work = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="prace" className="py-20 md:py-28 bg-[#1a1a1a] text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[420px] h-[420px] rounded-full bg-[#c79a5b]/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="max-w-2xl">
          <span className="eyebrow-line">Naše práce</span>
          <h2 className="font-heading mt-5 text-[30px] sm:text-[38px] md:text-[52px] font-bold leading-tight">
            Kompletní rekonstrukce bytů
          </h2>
          <p className="mt-4 text-[16px] text-white/60">
            Prohlédněte si videoprohlídky našich kompletních rekonstrukcí bytů.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          {VIDEOS.map((v) => (
            <div key={v.title}>
              <button
                onClick={() => setActive(v)}
                className="group relative rounded-none overflow-hidden text-left w-full focus:outline-none focus:ring-2 focus:ring-[#c79a5b]"
              >
                <img
                  src={v.poster}
                  alt={v.title}
                  className="w-full h-72 md:h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/25 group-hover:bg-black/15 transition-colors" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 rounded-full bg-[#c79a5b] flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                    <Play size={26} className="text-[#1b2b45] ml-1" fill="#1b2b45" />
                  </span>
                </div>
              </button>
              <h3 className="font-heading mt-4 text-[24px] font-bold">{v.title}</h3>
            </div>
          ))}
        </div>
      </div>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <div
            className="relative w-full max-w-4xl aspect-video"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setActive(null)}
              className="absolute -top-11 right-0 text-white/80 hover:text-white flex items-center gap-1 text-sm font-semibold"
            >
              Zavřít <X size={20} />
            </button>
            {active.videoSrc ? (
              <video
                className="w-full h-full rounded-none bg-black"
                src={active.videoSrc}
                poster={active.poster}
                controls
                autoPlay
                playsInline
              />
            ) : (
              <iframe
                className="w-full h-full rounded-none"
                src={`https://www.youtube.com/embed/${active.youtubeId}?autoplay=1`}
                title={active.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Work;
